import Constants from 'root/constants';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    tagName: 'tr',

    events: {
        'click .view' : 'viewInvoice',
        'click .pay'  : 'payInvoice'
    },

    dom_handlers: {
        viewInvoice: function(e) {
            e.preventDefault();
            Modals.viewInvoice(this.model.id);
        },

        payInvoice: function(e) {
            Modals.payInvoice(this.model.id);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var content = '';

        var invoice_status = '';

        if (this.model.get('status') === Constants.PAID) {
            invoice_status = '<span class="badge-success-invert badge-small font-weight-medium">Paid</span>';
        } else if (this.model.get('status') === Constants.OVERDUE) {
            invoice_status = '<span class="badge-danger-invert badge-small font-weight-medium">Overdue</span>';
        } else {
            invoice_status = '<span class="badge-danger-invert badge-small font-weight-medium">Unpaid</span>';
        }

        var from = this.model.get('start_year') + '-' + Util.padLeft(this.model.get('start_month'), '00') + '-' + Util.padLeft(this.model.get('start_day'), '00');
        var to   = this.model.get('end_year') + '-' + Util.padLeft(this.model.get('end_month'), '00') + '-' + Util.padLeft(this.model.get('end_day'), '00');

        from = Util.moment(Date.parse(from) / 1000, false, false, false);
        to   = Util.moment(Date.parse(to) / 1000, false, false, false);

        var payment_date = Util.moment(this.model.get('paid_time'));

        content += '<td>' +
                        '<a class="view no-underline hover-underline" href="#">' +
                            '<span class="badge-primary-invert font-weight-medium cursor-pointer">#' + Util.padLeft(this.model.id, '00000000') + '</span>' +
                        '</a>' +
                    '</td>' +

                    //'<td>' + this.model.get('description') + '</td>' +
                    '<td>' + from + ' - ' + to + '</td>' +
                    '<td>' + payment_date + '</td>' +
                    '<td class="font-weight-semibold text-align-right">$' + ((this.model.get('amount') + this.model.get('credit')) / 100).toFixed(2) + '</td>' +
                    '<td class="success text-align-right">' + (this.model.get('credit') ? '-$' + (this.model.get('credit') / 100).toFixed(2) : '-') + '</td>' +
                    '<td class="text-align-right">' + invoice_status + '</td>' +

                    '<td class="text-align-right">' +
                        (this.model.get('status') === Constants.OVERDUE || this.model.get('status') === Constants.UNPAID ?
                        '<button class="tiny primary tooltip pay" data-title="Pay">Pay</button>' : '') +
                    '</td>';

        this.$el.html(content);

        return this;
    }
});